import React, { FC } from 'react';

import { ModalInfo } from '@.modal';
import { Button, Input } from '@.ui';
import { DeviceLicenseKeyStatusEnum } from '@/entities/Device/model';
import { createPreventDefault } from '@/Lib';

import S from './styles.module.scss';
import { useEditLicenseKeySocket } from './useEditLicenseKeySocket';

type EditLicenseKeyModalProps = {
    deviceId: number;
    licenseKeyInitial: string;
    updateDeviceLicenseKey: (deviceId: number, licenseKey: string) => void;
    licenseKeyStatus?: DeviceLicenseKeyStatusEnum | null;
};

export const EditLicenseKeySocketModal: FC<EditLicenseKeyModalProps> = ({ deviceId, licenseKeyInitial, updateDeviceLicenseKey, licenseKeyStatus }) => {
    const { isLoading, close, field, requestSaveLicenseKey, error } = useEditLicenseKeySocket({
        deviceId,
        licenseKeyInitial,
        updateDeviceLicenseKey,
    });

    const ModalContentData = (
        <div className={S.edit_license_key_modal}>
            <h1 className={S.edit_license_key_modal__title}>
                <span>Edit license key</span>
                <span className={S.edit_license_key_modal__title__status}>By Socket</span>
            </h1>

            <Input {...field('licenseKey').register()} required text={'License key'} />

            {error && <p className={S.edit_license_key_modal_error}>{error}</p>}

            <div className={S.edit_license_key_modal_actions}>
                <Button color="brown" disabled={isLoading} onClick={requestSaveLicenseKey}>
                    Save
                </Button>
                <Button onClick={createPreventDefault(close)}>Cancel</Button>
            </div>
        </div>
    );

    return <ModalInfo children={ModalContentData} />;
};
